import type { Investment } from '../types/content'

export const investments: Investment[] = [
  {
    name: 'Kora Labs',
    sector: 'Fintech',
    stage: 'Series A',
    location: 'Lagos',
    role: 'Investor',
    note: 'Cross-border settlement rails for African SMEs.',
  },
  {
    name: 'Marewa Health',
    sector: 'Health',
    stage: 'Seed',
    location: 'Nairobi',
    role: 'Board Member',
    note: 'Diagnostics infrastructure for primary care networks.',
  },
  {
    name: 'Studio Ova',
    sector: 'Venture Studio',
    stage: 'Founded',
    location: 'London',
    role: 'Founder',
    note: 'Operator-led studio building companies in frontier markets.',
  },
  {
    name: 'Tellus Grid',
    sector: 'Climate',
    stage: 'Series A',
    location: 'Accra',
    role: 'Advisor',
    note: 'Distributed solar financing for commercial buildings.',
  },
  {
    name: 'Ibadan Freight',
    sector: 'Logistics',
    stage: 'Seed',
    location: 'Ibadan',
    role: 'Investor',
    note: 'Middle-mile freight matching across the corridor.',
  },
  {
    name: 'Nova Talent Co.',
    sector: 'Future of Work',
    stage: 'Pre-seed',
    location: 'Remote',
    role: 'Advisor',
    note: 'Placing African engineers into global product teams.',
  },
  {
    name: 'Aleph Capital',
    sector: 'Asset Management',
    stage: 'Fund I',
    location: 'London',
    role: 'Board Member',
    note: 'Emerging-manager fund investing at pre-seed.',
  },
  {
    name: 'Sable & Field',
    sector: 'Consumer',
    stage: 'Series A',
    location: 'Cape Town',
    role: 'Investor',
    note: 'Premium consumer brand scaling across three markets.',
  },
  {
    name: 'Orunmila AI',
    sector: 'Artificial Intelligence',
    stage: 'Seed',
    location: 'Lagos',
    role: 'Advisor',
    note: 'Language models trained for West African languages.',
  },
  {
    name: 'Bloom Ledger',
    sector: 'Fintech',
    stage: 'Pre-seed',
    location: 'Kigali',
    role: 'Investor',
    note: 'Working-capital underwriting for informal retailers.',
  },
  {
    name: 'The Founders Table',
    sector: 'Community',
    stage: 'Founded',
    location: 'Global',
    role: 'Founder',
    note: 'A private network of 500+ operators and investors.',
  },
  {
    name: 'Verda Agritech',
    sector: 'Agriculture',
    stage: 'Series B',
    location: 'Nairobi',
    role: 'Board Member',
    note: 'Input financing and yield data for smallholder farms.',
  },
]

export const investmentRoles = [
  'All',
  'Founder',
  'Investor',
  'Advisor',
  'Board Member',
] as const
